import React from 'react';
import { Button } from '../../ui/button';

interface Initial2FASetupProps {
  onEnableClick: () => void;
}

export const Initial2FASetup: React.FC<Initial2FASetupProps> = ({ onEnableClick }) => {
  return (
    <div className="flex items-center justify-between p-4 bg-gray-800/30 rounded-lg">
      <div className="space-y-1">
        <div className="text-sm font-medium text-white">Enable 2FA</div>
        <div className="text-sm text-gray-400">Add an extra layer of security to your account</div>
      </div>
      <Button variant="outline" onClick={onEnableClick}>Set up 2FA</Button>
    </div>
  );
};